// extracted by mini-css-extract-plugin
module.exports = {"peopleBlock":"style_peopleBlock__FVYkC"};